import { Util } from "@xt/xtbase";

const { getUrl } = Util;

/** 后台用规则页地址占位，避免 App 把 /aicopy?followStrategyId=15 拦回裸 /aicopy */
const LOCKUP_RULES_PATH = "/activity/aicopy-lockup-rules";
const AICOPY_FOLLOW_21 = "/aicopy?followStrategyId=21";

function bannerPathname(link) {
  if (!link) return "";
  if (/^(https?:)?\/\//.test(link)) {
    try {
      const href = link.startsWith("//") ? `https:${link}` : link;
      return new URL(href).pathname || "";
    } catch {
      return "";
    }
  }
  return String(link).split("?")[0].split("#")[0];
}

export function isAicopyLockupRulesBannerLink(link) {
  const pathname = bannerPathname(link).replace(/\/$/, "") || "/";
  const normalized = Util.stripNextI18nPathForMatch(pathname).replace(/\/$/, "") || "/";
  return normalized === LOCKUP_RULES_PATH;
}

/** 规则页占位链接改去策略 21；其余链接原样返回 */
export function resolveHomeBannerLink(link) {
  if (!link) return link;
  if (isAicopyLockupRulesBannerLink(link)) return AICOPY_FOLLOW_21;
  return link;
}

export function openResolvedHomeBannerLink(link) {
  const resolved = resolveHomeBannerLink(link);
  if (!resolved) return false;
  if (resolved === link) return false;
  window.location.href = getUrl(resolved);
  return true;
}
